import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { TrainingProvider } from './context/TrainingContext';
import LoginPage from './pages/LoginPage';
import AppLayout from './layouts/AppLayout';
import Profile from './pages/Profile';
import TrainingList from './pages/posp/TrainingList';
import TrainingModule from './pages/posp/TrainingModule';
import TrainingAssessment from './pages/posp/components/TrainingAssessment';


// Redirects to login if not authenticated
const ProtectedRoute = ({ children }) => {
    const { user } = useAuth();
    if (!user) return <Navigate to="/login" replace />;
    return children;
};

const AppRoutes = () => {
    const { user } = useAuth();

    return (
        <Routes>
            <Route path="/login" element={user ? <Navigate to="/app/profile" replace /> : <LoginPage />} />
            <Route
                path="/app"
                element={
                    <ProtectedRoute>
                        <AppLayout />
                    </ProtectedRoute>
                }
            >
                <Route path="profile" element={<Profile />} />
                <Route path="training" element={<TrainingList />} />
                <Route path="training/:moduleId" element={<TrainingModule />} />
                <Route path="training/:moduleId/assessment" element={<TrainingAssessment />} />
                <Route index element={<Navigate to="profile" replace />} />
            </Route>

            {/* Root redirect */}
            <Route path="/" element={<Navigate to={user ? '/app/profile' : '/login'} replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    );
};

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <TrainingProvider>
                    <BrowserRouter>
                        <AppRoutes />
                    </BrowserRouter>
                </TrainingProvider>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
